export class Customer {
    constructor() {
        this.customeraddress
    }
    CustomerID: number = 0;
    CustomerCode: string;
    CustomerName: string;
    CustomerBalance: number;
    ContactID: number;
    CompanyName: string;
    ShipAddress1: string;
    ShipAddress2: string;
    ShipCity: string;
    ShipState: string;
    ShipCountry: string;
    ShipCode: string;
    BillingAddress1: string;
    BillingAddress2: string;
    BillingCity: string;
    BillingState: string;
    BillingCountry: string;
    BillingCode: string;
    Telephone1: string;
    Telephone2: string;
    Email: string;
    Fax: string;
    Website: string;
    PaymentTerm: string;;
    CurrencyCode: string;
    CustomerSince: string;
    Deleted: boolean;
    Remark: string;
    CreateDate: string;
    CreateBy: number;
    UpdateDate: string;
    UpdateBy: number;
    CustomerShipCode: string;
    CompanyID: number;
    BillingCountryCode: string;
    ShipCountryCode: string;
    BillingMoo: string;
    BillingSoi: string;
    BillingSubDistrict: string;
    BillingStreet: string;
    ShipMoo: string;
    ShipSoi: string;
    ShipStreet: string;
    ShipSubDistrict: string;
    TaxID: string;
    BranchCode: string;
    Telephone: string;
    HasTransaction: number;
    ContactName: string;
    ContactEmail: string;
    ContactTelNo: string;
    SalesPIC: string;
    CustomerGroupID: number;
    CustomerGroupName: string;
    ShipCountryName: string;
    BillingCountryName: string;
    SalesPriceTier: number;
    InitWarehouse: number;
    SalesAccountID: number;
    ARAccountID: number;
    ColorCode: string;
    TransportTypeID: number;
    TransportTypeName: string;;
    Status: boolean = true;
    ShippingWarehouseID: number;
    URL: string;
    IPAddress: string;
    customeraddress: Array<CustomerAddress>;
}

export class CustomerAddress {
    CustomerAddressID: number;
    CustomerID: number;
    AddressName: string;
    AddressType: string;
    AddressLine1: string;
    AddressLine2: string;
    City: string;
    State: string;
    Country: string;
    PostalCode: string;
    ColorCode: string;
    CreateDate: string;
    Telno: string;
    Fax: string;
    CreateBy: number;
    UpdateDate: string;
    UpdateBy: number;
    CountryName: string;
}

export class CustomerForDD {
    CustomerID: number;
    CustomerCode: string;
    CustomerName: string;
    CustomerBalance: number;
    ContactID: number;
    CompanyName: string;
    ShipAddress1: string;
    ShipAddress2: string;
    ShipCity: string;
    ShipState: string;
    ShipCountry: string;
    ShipCode: string;
    BillingAddress1: string;
    BillingAddress2: string;
    BillingCity: string;
    BillingState: string;
    BillingCountry: string;
    BillingCode: string;
    Telephone1: string;
    Telephone2: string;
    Email: string;
    Fax: string;
    Website: string;
    PaymentTerm: string;;
    CurrencyCode: string;
    CustomerSince: string;
    Deleted: boolean;
    Remark: string;
    CreateDate: string;
    CreateBy: number;
    UpdateDate: string;
    UpdateBy: number;
    CompanyID: number;
    BillingCountryCode: string;
    ShipCountryCode: string;
    BillingMoo: string;
    BillingSoi: string;
    BillingSubDistrict: string;
    BillingStreet: string;
    ShipMoo: string;
    ShipSoi: string;
    ShipStreet: string;
    ShipSubDistrict: string;
    TaxID: string;
    BranchCode: string;
    Telephone: string;
    HasTransaction: number;
    ContactName: string;
    ContactEmail: string;
    ContactTelNo: string;
    SalesPIC: string;
    CustomerGroupID: number;
    CustomerGroupName: string;
    ShipCountryName: string;
    BillingCountryName: string;
    SalesPriceTier: number;
    InitWarehouse: number;
    SalesAccountID: number;
    ARAccountID: number;
    ColorCode: string;
    TransportTypeID: number;
    TransportTypeName: string;;
    Status: boolean = true;
    URL: string;
    IPAddress: string;
    customeraddress: Array<CustomerAddress>;
}

export class CustomerGroup {
    CustomerGroupId: number;
    CompanyId: number;
    CustomerGroupCode: string;
    CustomerGroupName: string;
    BarcodeID: number;
    Deleted: boolean;
    CreateDate: string;
    CreateBy: number;
    UpdateDate: string;
    UpdateBy: number;
}

export class CustomerList {
    constructor() {
        this.CUSTOMER_ID = 0;
    }
    CUSTOMER_ID: number;
    CODE: string;
    NAME: string;
    STATUS: number;
    CREDIT_TERM: number;
    WORKING_HPD: number;
}

export class CustomerSite {
    CUSTOMER_ID: number;
    CODE: string;
    NAME: string;
    WORKING_HPD: number;
    CREDIT_TERM: number;
    STATUS: number;
    FLAG_DELETE: number;
    SITE_ID: number;
    CONTACT_PERSON: string;
    CONTACT_EMAIL: string;
    CONTACT_PHONE: string;
    SITE_AREA: string;
    SITE_NAME: string;
    SortOrder: string;
}

export class CustomerDataSave {
    constructor() {
        this.CustomerSite = new Array<CustomerSite>();
        this.CustomerList = new CustomerList();
    }
    CustomerSite: Array<CustomerSite>;
    CustomerList: CustomerList;
}





// WEBPACK FOOTER //
// ./src/app/model/customer.model.ts